var _rect, _rect2, _rect3, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _circle4, _circle5, _circle6, _rect13, _rect14, _rect15, _rect16, _rect17, _polygon, _path, _polygon2, _path2, _polygon3, _path3, _polygon4, _polygon5, _path4, _polygon6, _path5, _rect18, _path6, _circle7, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 805.94744,
    height: 735.26758,
    viewBox: "0 0 805.94744 735.26758",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.15277,
    y: 177.53389,
    width: 357.79467,
    height: 229.14762,
    fill: "#f2f2f2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.38383,
    y: 206.27472,
    width: 337.33256,
    height: 186.8504,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 177.33105,
    width: 357.79468,
    height: 15.20043,
    fill: "#25d125"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.29574,
    cy: 185.10232,
    r: 2.81728,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.98944,
    cy: 185.10232,
    r: 2.81728,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.68313,
    cy: 185.10232,
    r: 2.81728,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41.03512,
    y: 225.66196,
    width: 86.67858,
    height: 148.0759,
    fill: "#f2f2f2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 142.67606,
    y: 225.66196,
    width: 72.23215,
    height: 40.75957,
    fill: "#25d125"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 142.67606,
    y: 277.7723,
    width: 72.23215,
    height: 43.85523,
    fill: "#f2f2f2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 142.67606,
    y: 332.9783,
    width: 72.23215,
    height: 40.75957,
    fill: "#f2f2f2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 230.38653,
    y: 225.66196,
    width: 86.67858,
    height: 64.53067,
    fill: "#f2f2f2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 230.38653,
    y: 309.2072,
    width: 86.67858,
    height: 64.53067,
    fill: "#f2f2f2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 448.15277,
    y: 177.53389,
    width: 357.79467,
    height: 229.14762,
    fill: "#f2f2f2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 458.38383,
    y: 206.27472,
    width: 337.33256,
    height: 186.8504,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 177.33105,
    width: 357.79468,
    height: 15.20043,
    fill: "#25d125"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 459.29574,
    cy: 185.10232,
    r: 2.81728,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 469.98944,
    cy: 185.10232,
    r: 2.81728,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 480.68313,
    cy: 185.10232,
    r: 2.81728,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 678.30808,
    y: 225.66197,
    width: 86.67858,
    height: 148.0759,
    fill: "#f2f2f2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 489.11328,
    y: 225.65938,
    width: 174.83378,
    height: 40.75957,
    fill: "#25d125"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 489.11328,
    y: 277.76971,
    width: 174.83378,
    height: 43.85523,
    fill: "#f2f2f2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 489.11328,
    y: 332.97571,
    width: 174.83378,
    height: 40.75957,
    fill: "#f2f2f2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 398.94744,
    width: 2,
    height: 109.26758,
    fill: "#ccc"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "600.947 177.268 598.947 177.268 598.947 110.268 200.947 110.268 200.947 177.268 198.947 177.268 198.947 108.268 600.947 108.268 600.947 177.268",
    fill: "#ccc"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M611.68875,387.83386l-1.50587-7.52935s-22.14933-7.52935-24.62749,7.52935Z",
    transform: "translate(-197.02628 -82.36621)",
    fill: "#e6e6e6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "372.154 720.046 357.633 720.045 350.725 664.036 372.156 664.037 372.154 720.046",
    fill: "#ffb8b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M572.88316,816.48776,526.0618,816.486v-.59222A18.22516,18.22516,0,0,1,544.286,797.66992h.00116l28.59689.00116Z",
    transform: "translate(-197.02628 -82.36621)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.075 720.046 436.596 720.045 443.504 664.036 422.073 664.037 422.075 720.046",
    fill: "#ffb8b8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M615.39755,797.67108l28.5969-.00116h.00115a18.22516,18.22516,0,0,1,18.22418,18.22389v.59222l-46.82136.00173Z",
    transform: "translate(-197.02628 -82.36621)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "435.745 337.091 452.309 335.585 462.85 385.279 461.344 430.455 444.78 490.69 422.192 477.137 434.239 415.396 435.745 337.091",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "446.229 485.419 442.521 517.042 447.039 590.83 447.039 700.788 418.427 699.253 412.404 584.806 395.839 532.101 383.792 592.336 376.263 705.276 346.898 702.922 346.898 591.939 346.145 511.019 356.686 479.396 446.229 485.419",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M581.57136,389.33973s10.54108-15.0587,30.11739-4.51761l9.03522,12.047,28.61152,21.08217L643.312,488.72712l7.52935,88.8463-106.91674-1.50587,18.07043-88.8463V392.35147Z",
    transform: "translate(-197.02628 -82.36621)",
    fill: "#2f2e41"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "442.521 360.58 451.155 463.818 440.262 407.867 442.521 360.58",
    opacity: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M561.00757,596.7716a11.10632,11.10632,0,0,0-2.99352-16.7651l3.21927-25.17493-14.82159-5.68767-4.0469,35.61573a11.16655,11.16655,0,0,0,18.64274,12.012Z",
    transform: "translate(-197.02628 -82.36621)",
    fill: "#ffb8b8"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 542.41875,
    y: 561.00886,
    width: 24.09391,
    height: 10.54109,
    transform: "translate(911.90513 1050.19259) rotate(-180)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M577.80668,405.15136l-15.81163-12.79989s-11.294-.75294-12.79989,15.81163-3.33781,87.34043-3.33781,87.34043L540.16,566.2794l31.62326,1.50587,6.02347-76.6037Z",
    transform: "translate(-197.02628 -82.36621)",
    fill: "#2f2e41"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 598.32961,
    cy: 341.70654,
    r: 30.23917,
    transform: "translate(-185.52333 620.44441) rotate(-61.33681)",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M596.07082,368.38125a30.67347,30.67347,0,0,0,20.06795-57.65151,35.8683,35.8683,0,0,0-16.936-3.03924c-9.04372.47548-17.83367,3.818-26.88653,3.57174l-1.31214,2.10915-4.94513-1.1993-1.05965,3.92608-1.30256-.04509c-2.33327,4.336,1.42084,10.54382,6.34451,10.49128,1.94936-.0208,3.79255-.83294,5.69875-1.2414s4.151-.30665,5.46543,1.133c1.70825,1.871.96462,4.79061.60844,7.29894s.53342,5.887,3.06559,5.96885c1.2935.04183,2.52372-.88577,3.79472-.64189,1.4804.28407,2.22892,2.07169,2.01278,3.56352a14.18009,14.18009,0,0,1-1.77124,4.135c-3.67068,7.32733-.57119,17.29465,6.60746,21.24821",
    transform: "translate(-197.02628 -82.36621)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M787.47372,817.63379h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-197.02628 -82.36621)",
    fill: "#ccc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.f8f899d48fe62bdae11b55832e6b4670.svg";
export { ForwardRef as ReactComponent };